<style lang="less" scoped>
  .col {
    display: flex;
    padding: 3px 12px;
  }
</style>
<template>
  <v-col
    v-ripple
    class="col"
    v-bind="$attrs"
    :cols="cols"
    v-on="$listeners"
  >
    <slot />
  </v-col>
</template>
<script>
  export default {
    inheritAttrs: false,
    props: {
      cols: {
        type: [String, Number],
        default: 12
      }
    },
  }
</script>
